import React from "react";
import "primereact/resources/primereact.min.css"; //core css
import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.css";
// import "react-date-picker/dist/DatePicker.css";
// import "react-calendar/dist/Calendar.css";
// import "font-awesome/css/font-awesome.min.css";
import 'primereact/resources/primereact.min.css';
import "primereact/resources/themes/lara-light-blue/theme.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { createRoot } from "react-dom/client";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import "./index.css";
import App from "./App";
import { PersistGate } from "redux-persist/lib/integration/react";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import { PrimeReactProvider } from "primereact/api";

// import 'react-quill/dist/quill.snow.css';
console.log('Environment Variables:');
console.log('ENVIRONMENT:', process.env.REACT_APP_ENVIRONMENT);
console.log('API URL STAGING:', process.env.REACT_APP_API_URL_STAGING);
console.log('API URL PRODUCTION:', process.env.REACT_APP_API_URL_PRODUCTION);

const root = createRoot(document.getElementById("root"));
const value = {
  ripple: true,
};
root.render(
  // <React.StrictMode>
    <Provider store={store} value={value}>
      <PersistGate loading={null} persistor={persistor}>
        <PrimeReactProvider>
          <App />
        </PrimeReactProvider>
      </PersistGate>
    </Provider>
  // </React.StrictMode>
);
